module.exports = __webpack_public_path__ + "img/emp-dir-list.694c3d73.svg";